import {Språklager} from "./Spraaklager";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Språk} from "./Spraak";
import {IPromise, IWindowService} from "angular";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import moment from "moment";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {Kontekst} from "../Kontekst";
import {BrukerRessurs} from "../ressurser/BrukerRessurs";
import {Debugger} from "debug";
import {BehaviorSubject, distinctUntilChanged} from "rxjs";
import {filter} from "rxjs/operators";

const debuger = require('debug');
const debug:Debugger = debuger('Språkvalg');

export class Språkvalg {

    static regNavn = "Språkvalg";

    private _tilgjengeligSpråk: Språk[];
    private _aktivtSpråk: Språk;

    private språkSubject = new BehaviorSubject<Språk>(null);

    static forInjisering() {
        return [Språklager.regNavn, Konfigurasjon.regNavn, BrukerRessurs.regNavn, Kontekst.regNavn, regNavn.gettext.gettextCatalog, regNavn.moment.amMoment, regNavn.ng.$window, Språkvalg]
    }

    constructor(private språklager: Språklager, private konfigurasjon:Konfigurasjon, private brukerRessurs:BrukerRessurs, private kontekst:Kontekst, private gettextCatalog: gettextCatalog, private amMoment: AngularMoment, private $window:IWindowService) {
        this._tilgjengeligSpråk = Språk.tilgjengeligSpråk();
        this.settSpråk(Språk.standardSpråk());
    }

    /**
     * Setter initiell språk, overstyres potensielt senere via kall til {@link #oppdaterFraKontekst}.
     *
     * Slår opp brukers foretrukne språk. Om språket allerede er lagret i localStorage benyttes dette,
     * ellers benyttes angitt standardSpråk.
     */
   initSpråk(avhengigheter: SpråkvalgAvhengigheter) {
        this.lastSpråk(avhengigheter.poFiler());

        return this.språklager.harValgtSpråk()
            .then(harValgt => harValgt ? this.språklager.hentValgtSpråk() : avhengigheter.standardSpråk())
            .then(språk => this.angiSpråk(språk));
    }

    /** Oppdaterer språk i bruk fra angitt kontekst, dvs fra språk satt på bruker */
    oppdaterFraKontekst(kontekst:Kontekst){
        const språk = Språk.finnSpråkFraTag(kontekst.autentisertBruker().spraak) ;
        if (!_.isNil(språk)) this.angiSpråk(språk);
    }

    aktivtSpråk():Språk{
        return this._aktivtSpråk;
    }

    tilgjengeligSpråk() {
        return this._tilgjengeligSpråk;
    }

    /** Setter språk som skal brukes i gui-tekster og utskrift av klokkeslett. */
    angiSpråk(språk: Språk) {
        this.settSpråk(språk)
        this.språklager.lagreValgtSpråk(språk);
        this.språkSubject.next(språk);
    }

    språk$() {
        return this.språkSubject.asObservable()
          .pipe(
            filter(språk => !_.isEmpty(språk)),
            distinctUntilChanged((prev, curr) => prev.servertag === curr.servertag)
          )
    }

    /** Setter språk som skal brukes i gui-tekster og utskrift av klokkeslett.
     * Persisterer valg språk for innlogget bruker */
    angiSpråkOgPersister(språk: Språk) {
        if (this.kontekst.erAutentisert() && this.kontekst.autentisertBruker().spraak != språk.servertag) {
            this.brukerRessurs.oppdaterSpråk(språk);
            this.kontekst.autentisertBruker().spraak = språk.servertag;
            this.kontekst.autentisert().bruker.spraak = språk.servertag;
        }
        this.angiSpråk(språk)//må skje etter at kontekst.autentisert().bruker.spraak er oppdatert for korrekt synk med ng2 GjeldendeLokale
    }

    private lastSpråk(oversettelser:any[]){
        //språk benyttet av moment (datoformatering)
        require('moment/locale/nb');
        require('moment/locale/nn');
        require('moment/locale/en-gb');

        // initialiser angular-gettext i18n støtte
        this.gettextCatalog.baseLanguage = 'nb';

        this.gettextCatalog.debug = this.konfigurasjon.miljø === 'test';
        this.gettextCatalog.showTranslatedMarkers = this.konfigurasjon.miljø === 'test';
        //last oversettelser - po filer blir kompiler til json via angular-gettext-loader i webpack
        oversettelser.forEach(oversettelse => {
            for (var språk in oversettelse) this.gettextCatalog.setStrings(språk, oversettelse[språk]);
        });
    }

    private settSpråk(språk: Språk) {
        debug('settSpråk', språk)
        this._aktivtSpråk = språk;
        this.gettextCatalog.setCurrentLanguage(språk.servertag)
        this.amMoment.changeLocale(språk.servertag)
        moment.locale(språk.servertag);
    }
}

export abstract class SpråkvalgAvhengigheter {
    static regNavn = 'SpråkvalgAvhengigheter';

    abstract standardSpråk(): IPromise<Språk>;

    abstract poFiler(): string[];
}
